module.exports = __webpack_public_path__ + "static/media/icon-character__marguerite-duras.c047208f.svg";